import { observable} from 'mobx';

export default class Cell{
    @observable active;
    @observable disabled;
    constructor(){
        this.disabled = true;
        this.active = false;
    }

    setActive(state){
        this.active = state;
    }
}



// WEBPACK FOOTER //
// ./src/shared/stores/objects/emptyCell.js